import { AppDispatch } from 'store/index';
import { setBackdropLoadingAction } from 'store/actions/mainPage';
import {
  initialAllPoints,
  vectorLayersSlice,
} from 'store/reducers/vectorLayers';
import { IPoint } from 'types/mainPage';
import { searchTabSlice } from 'store/reducers/searchTab';
import { resetClusterInfoAction } from '../searchTab';
import { getClusterInfoVL } from './constants';

export const setPointsActionVL =
  (points: IPoint[]) => (dispatch: AppDispatch) => {
    dispatch(vectorLayersSlice.actions.setFoundPoints(points));
    dispatch(vectorLayersSlice.actions.toggleShowPoints(true));
  };

export const setAllPointsActionVL =
  (allPoints: any) => (dispatch: AppDispatch) => {
    dispatch(vectorLayersSlice.actions.setAllFoundPoints(allPoints));
  };

export const getClusterInfoActionVL =
  (isLog: boolean, gid: string, layerId: number, coord: number[]) =>
  async (dispatch: AppDispatch) => {
    dispatch(setBackdropLoadingAction(true));
    const { info } = await getClusterInfoVL(isLog, gid, layerId);

    dispatch(
      searchTabSlice.actions.setClusterInfo({
        gid,
        info,
        coordinates: coord,
      })
    );
    dispatch(setBackdropLoadingAction(false));
  };

export const updateClusterInfoVL =
  (info: string) => async (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.updateOnlyClusterInfo(info));
  };

export const resetPointsActionVL = () => (dispatch: AppDispatch) => {
  dispatch(vectorLayersSlice.actions.setFoundPoints([]));
  dispatch(vectorLayersSlice.actions.setAllFoundPoints(initialAllPoints));
};

export const setNeedUpdateClusterInfoAction =
  (state: boolean) => (dispatch: AppDispatch) => {
    dispatch(vectorLayersSlice.actions.toggleNeedUpdate(state));
  };

export const resetClusterPointsAndInfoAction =
  () => (dispatch: AppDispatch) => {
    dispatch(vectorLayersSlice.actions.resetVectorLayerData());
    dispatch(resetClusterInfoAction());
  };

export const setShowPointsVL = (state: boolean) => (dispatch: AppDispatch) => {
  dispatch(vectorLayersSlice.actions.toggleShowPoints(state));
};
